import util from '@bmp-vue/core/api/util'

const controller = 'Asigni'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  PostAsigni: function (acao, codigoIntegracao, dto, codigoPortal, method = null) {
    var request = { Dto: dto, Acao: acao, CodigoIntegracao: codigoIntegracao, CodigoPortal: codigoPortal, Metodo: method }
    return util.Axios.Post(`${controller}/PostAsigni`, request)
  },
  IncluirEnvelope: function (dto, codigoPortal, codigoIntegracao = null) {
    var request = { Dto: dto, CodigoPortal: codigoPortal, CodigoIntegracao: codigoIntegracao }
    return util.Axios.Post(`${controller}/IncluirEnvelope`, request)
  },
  PublicarEnvelope: function (codigoOperacao, codigoPortal, codigoIntegracao = null) {
    var request = { CodigoPortal: codigoPortal, CodigoIntegracao: codigoIntegracao }
    return util.Axios.Post(`${controller}/PublicarEnvelope/${codigoOperacao}`, request)
  },
  ReenviarEmailAssinatura: function (codigoOperacao, documentoFederal, codigoPortal, codigoIntegracao = null) {
    var request = { CodigoPortal: codigoPortal, CodigoIntegracao: codigoIntegracao }
    return util.Axios.Post(`${controller}/ReenviarEmailAssinatura/${codigoOperacao}/DocumentoAssinante/${documentoFederal}`, request)
  },
  SituacaoAssinaturas: function (codigoOperacao, codigoPortal, codigoIntegracao = null) {
    return util.Axios.GetParams(`${controller}/SituacaoAssinaturas/${codigoOperacao}`, { codigoPortal, codigoIntegracao })
  },
  EnviarEnvelopeAsigni: function (dto) {
    return util.Axios.Post(`${controller}/EnviarEnvelopeAsigni`, dto)
  }
})
